import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { THEMES } from '../themes/themes.config';

/**
 * Applies a service's visual theme (CSS variables) to the document's root element.
 */
@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  /**
   * Sets the CSS variables of the theme associated with the given service name.
   * If the name doesn't match any registered theme, does nothing.
   * @param name Name of the service whose theme is to be applied
   */
  setTheme(name: string): void {
    if (name && THEMES[name]) {
      const theme = THEMES[name];
      Object.keys(theme).forEach((key) => {
        this.document.documentElement.style.setProperty(key, theme[key]);
      });
    }
  }
}
